// Known limitation: slice: 100 means client-side duplicate-name validation only
// covers the first 100 cost tables. Tenants with more than 100 tables may not
// see the inline duplicate error until the server rejects the request. The
// server-side uniqueness check in saas-am-cost is always the authoritative guard.
export const COST_TABLES_REQUEST = {
  page: 1,
  slice: 100,
  sort_key: 'updated_at',
  sort_descending: true,
  search_value: null,
};
